import {MatDialogRef} from "@angular/material/dialog";
import {LoginComponent} from "src/app/components/login/login.component";
import {Component, OnInit} from "@angular/core";
import {RegisterComponent} from "src/app/components/register/register.component";
import {DialogService} from "src/app/services/dialog.service";
import {ActivatedRoute, Router} from "@angular/router";
import {PasswordResetComponent} from "src/app/components/password-reset/password-reset.component";

@Component({
    selector: "app-dialog",
    template: "",
})
export class RouteDialogComponent implements OnInit {
    urlToComponent: string;
    dialogRef: MatDialogRef<any, any>;

    constructor(
        public dialogService: DialogService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.openDialog();
    }

    openDialog(): void {
        this.route.url.subscribe((result) => {
            this.urlToComponent = result[0].path;
        });

        if (this.urlToComponent === "login")
            this.dialogRef = this.dialogService.openDialog(LoginComponent);
        else if (this.urlToComponent === "register")
            this.dialogRef = this.dialogService.openDialog(RegisterComponent);
        else if (this.urlToComponent === "reset-password")
            this.dialogRef = this.dialogService.openDialog(PasswordResetComponent);

        this.dialogRef.afterClosed().subscribe(() => {
            this.router.navigate(["../"], {relativeTo: this.route});
        });
    }

    ngOnInit() {
    }
}
